<template>
  <div class="bg-background min-h-screen">
    <!-- Hero Section -->
    <section class="bg-gradient-to-r from-primary to-primary-light text-white py-16">
      <div class="container mx-auto px-4">
        <h1 class="text-4xl font-bold mb-4">Salary Guide</h1>
        <p class="text-xl opacity-90">Make informed career decisions with our comprehensive salary data</p>
      </div>
    </section>

    <section class="container mx-auto px-4 py-8">
      <div class="bg-card border border-border rounded-lg shadow-md p-8 text-center mb-8">
        <h2 class="text-xl font-medium text-foreground mb-4">Coming Soon</h2>
        <p class="text-muted-foreground">
          Our comprehensive salary guide is currently under development.
          Check back soon for detailed salary information across various industries and roles.
        </p>
      </div>

      <!-- Placeholder Stats -->
      <div class="bg-card border border-border rounded-lg shadow-md p-6 mb-8">
        <h2 class="text-xl font-semibold text-foreground mb-4">Salary Insights</h2>
        <p class="text-muted-foreground mb-4">
          We're gathering data to provide you with valuable insights about:
        </p>
        <ul class="list-disc list-inside text-muted-foreground space-y-2 pl-4">
          <li>Industry-specific salary ranges</li>
          <li>Experience level compensation differences</li>
          <li>Location-based salary variations</li>
          <li>Skills that command premium pay</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SalaryGuidePage'
}
</script>